/** Shared reCAPTCHA disclosure copy for overlay LoginForm and marketing chrome. */
export const RECAPTCHA_NOTICE_LABEL = 'Protected by reCAPTCHA';
export const RECAPTCHA_LOGO_URL = 'https://www.gstatic.com/recaptcha/api2/logo_48.png';

/** Static HTML for marketing site-chrome (same markup as RecaptchaNotice). */
export function recaptchaNoticeHtml(): string {
  return (
    '<p class="login-form__recaptcha">' +
    `<img class="login-form__recaptcha-icon" src="${RECAPTCHA_LOGO_URL}" alt="" width="20" height="20" decoding="async">` +
    `<span>${RECAPTCHA_NOTICE_LABEL}</span>` +
    '</p>'
  );
}
